"use client";

import { memo } from "react";
import { Box, HStack, VStack, Text } from "@chakra-ui/react";
import type { AtsJobDetails } from "../types";
import { SectionTitle } from "./SectionTitle";

export interface LanguagesSectionProps {
  languages: AtsJobDetails["professional_languages"];
}

export const LanguagesSection = memo<LanguagesSectionProps>(({ languages }) => {
  if (!languages || languages.length === 0) return null;

  return (
    <Box as="section" aria-label="Languages" mb={6}>
      <SectionTitle title="Languages" />
      <VStack align="stretch" gap={2}>
        {languages.map((lang, index) => (
          <HStack
            key={`${lang.name}-${index}`}
            justify="space-between"
            align="center"
          >
            <Text textStyle="sm" color="neutral.500" lineHeight="1.6">
              {lang.name}
            </Text>
            <Text
              textStyle="sm"
              color="neutral.500"
              lineHeight="1.6"
              textAlign="right"
            >
              {lang.level}
            </Text>
          </HStack>
        ))}
      </VStack>
    </Box>
  );
});
LanguagesSection.displayName = "LanguagesSection";
